export default {"src":"/_next/static/media/excel.34f1cda5.svg","height":22,"width":21};